import { getCookie } from './cookie_utils';


function navigate() {
    var e = document.getElementById("intlselect");
    if (typeof analytics !== 'undefined') {
        analytics.track("Web Country Changed", {
            "new_country": e.options[e.selectedIndex].value
        })
    }
    saveTheme(e.options[e.selectedIndex].value, false)
}

function saveTheme(themeValue, multiLingualCookieSet) {
    if (multiLingualCookieSet === undefined){
        multiLingualCookieSet = false
    }
    var theme = document.getElementById('prefix_to_add').content;
    var available_locales = $('#available_locales').data();
    if (themeValue != "US"){
        var replacement =  "/" + themeValue.toLowerCase() + "/";
    }
    else {
        var replacement = "/";
    }
    if (multiLingualCookieSet){
        setMultiLingualCookie('multiLingualSelected', true, 365);
    }
    if(available_locales && JSON.stringify(available_locales).indexOf(themeValue) < 0){
        document.location.href = "/";
    }
    else {
        var url = window.location.pathname.replace(theme, replacement)
        window.location.href = url;
    }
}

function setMultiLingualCookie(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays==null || nDays==0)
        nDays=1;
    expire.setTime(today.getTime() + 3600000*24*nDays);
    document.cookie = cookieName+"="+escape(cookieValue) + ";path=/;expires="+expire.toGMTString();
}

// listener on intl banner
let intl_continue = document.getElementById("intlcnt");
if (intl_continue) {
    intl_continue.addEventListener("click", navigate);
}
// international banner
let should_show_banner = document.getElementById('should_show_int_banner').content
if (should_show_banner === "True" && getCookie("intlmodalclose") !== "true") {
    let intl_nav_banner = document.getElementById("international-nav")
    if (intl_nav_banner){
        intl_nav_banner.style.display = "inline-block"
    }
}
// href prefix updater
const prefix_to_add = document.getElementById('prefix').content
if (prefix_to_add) {
    const anchors = document.getElementsByTagName("a");
    for (var i = 0; i < anchors.length; i++) {
        var href = anchors[i].getAttribute("href")
        var exclusions = [".com", "http", "+", "tel:", ".net"]
        const revised_prefix = prefix_to_add + "/"
        exclusions.push(revised_prefix)
        if (href && href.indexOf("#") !== 0) {
            var is_valid_url = !exclusions.some(function(el) {
                return href.indexOf(el) >= 0
            });
            if (is_valid_url) {
                anchors[i].href = prefix_to_add + anchors[i].pathname + anchors[i].hash
            }
        }
    }
}

// autoplay videos
var isPartiallyInViewport = function(el) {
    var top_of_element = $(el).offset().top;
    var bottom_of_element = $(el).offset().top + $(el).outerHeight();
    var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
    var top_of_screen = $(window).scrollTop();
    return bottom_of_screen > top_of_element && top_of_screen < bottom_of_element;
}
var autoPlayVideoInViewport = function(){$('video').each(function(){if ($(this).attr('src') && $(this).attr('src').indexOf('demo-samsara_for_fleets') === -1) {if (isPartiallyInViewport($(this)[0]) === true) {$(this)[0].play(); } else { $(this)[0].pause(); }}})};
$(document).on('scroll', autoPlayVideoInViewport);
